// // Context/ProductContext.jsx
// import React, { createContext, useContext, useState, useEffect } from "react";

// const ProductContext = createContext();

// export const ProductProvider = ({ children }) => {
//   const [productId, setProductId] = useState(() => {
//     // initial value localStorage la irundha load pannu
//     return localStorage.getItem("productId") || "";
//   });

//   useEffect(() => {
//     if (productId) {
//       localStorage.setItem("productId", productId);
//       alert("set product id")
//     }
//   }, [productId]);

//   return (
//     <ProductContext.Provider value={{ productId, setProductId }}>
//       {children}
//     </ProductContext.Provider>
//   );
// };

// export const useProduct = () => useContext(ProductContext);
// Context/ProductContext.jsx



// import React, { createContext, useContext, useState, useEffect } from "react";

// const ProductContext = createContext();

// export const ProductProvider = ({ children }) => {
//   const [productId, setProductId] = useState(() => {
//     // load initial productId from localStorage
//     return localStorage.getItem("productId") || "";
//   });

//   const [activeTabLabel, setActiveTabLabel] = useState("");

//   // Sync productId with localStorage
//   useEffect(() => {
//     if (productId) {
//       localStorage.setItem("productId", productId);
//       alert("set product id")
//       // Optional alert for debugging
//       console.log("Product ID set:", productId);
//     }
//   }, [productId]);

//   return (
//     <ProductContext.Provider
//       value={{ productId, setProductId, activeTabLabel, setActiveTabLabel }}
//     >
//       {children}
//     </ProductContext.Provider>
//   );
// };

// export const useProduct = () => useContext(ProductContext);


// Context/ProductContext.jsx
import React, { createContext, useContext, useState } from "react";

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [productId, setProductId] = useState(null);
  const [activeTabLabel, setActiveTabLabel] = useState("");

  return (
    <ProductContext.Provider value={{ productId, setProductId, activeTabLabel, setActiveTabLabel }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProduct = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error("useProduct must be used within ProductProvider");
  }
  return context;
};
